<!-- eslint-disable prettier/prettier -->
@let viewMode = effectiveViewMode();
@let currentCardsGrid = cardsGrid();

@if (loading()) {
  <div class="fixed inset-0 z-[9999]">
    <!-- Compact pill anchored to bottom-right -->
    <div
      [ngClass]="{
        'shadow-lg': !flat(),
        'bg-white': !flat(),
      }"
      class="absolute bottom-8 right-8 flex items-center gap-3 rounded-full px-5 py-3 border border-gray-100"
    >
      <span
        class="w-5 h-5 rounded-full border-2 border-gray-200 border-t-primary animate-spin flex-shrink-0"
      ></span>
      <span class="text-[13px] font-medium text-gray-500 whitespace-nowrap">Cargando…</span>
    </div>
  </div>
}

<div class="mx-auto">
  <div class="flex justify-between items-center mb-6">
    <h2 #tableTitleElement class="font-bold flex items-center" [class]="titleClass()">
      <button
        *ngIf="btnBack()"
        (click)="goBack()"
        class="mr-4 p-1 md:hidden cursor-pointer"
        aria-label="Go back"
      >
        <i class="fa-solid fa-chevron-left"></i>
      </button>
      <ng-container *ngIf="title()">{{ title() | translate }}</ng-container>
    </h2>
    <div class="flex space-x-2 items-center">
      @if (allowViewModeToggle()) {
        <!-- Switch para alternar entre vista de tabla y tarjetas -->
        <div class="flex items-center">
          <span class="mr-2 text-[14px] text-gray-600">
            <i class="fas fa-table"></i>
          </span>
          <label class="relative inline-flex items-center cursor-pointer">
            <input
              type="checkbox"
              class="sr-only peer"
              [checked]="viewMode === 'cards'"
              (change)="toggleViewMode()"
            />
            <div
              class="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:translate-x-[-100%] after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-sky-500"
            ></div>
          </label>
          <span class="ml-2 text-[14px] text-gray-600">
            <i class="fas fa-th"></i>
          </span>
        </div>
      }
      <!-- Botón de crear usando custom-button con el nuevo estilo e icono -->
      @if (showCreateButton() && permissionsService.hasPermissions(createPermission())) {
        <lib-custom-button
          [label]="btnLabel() | translate"
          variant="primary"
          icon="fa-solid fa-plus"
          size="md"
          class="hidden md:inline-flex"
          (clicked)="emitCreate()"
        ></lib-custom-button>
        <lib-custom-button
          label=""
          variant="primary"
          icon="fa-solid fa-plus"
          size="md"
          class="md:hidden"
          (clicked)="emitCreate()"
        ></lib-custom-button>
      }
    </div>
  </div>

  <div
    [ngClass]="{
      'shadow-sm': !flat(),
      'bg-white': !flat(),
      'p-4': !flat(),
      'md:p-6': !flat(),
      'rounded-[27px]': !flat(),
    }"
    class="relative overflow-hidden"
  >
    @if (useTableView()) {
      <!-- Vista de escritorio (tabla) -->
      <!-- New Filter Row -->
      @if (shouldShowFilterRow() && isFilterRowVisible()) {
        <!-- Spacer for filter toggle button column -->
        <div class="flex justify-end">
          @for (column of columns(); track column.key) {
            @if (column.filterType) {
              <div class="min-w-[175px] pl-6">
                @if (column.filterType === 'text') {
                  <lib-custom-input
                    [displayError]="false"
                    [placeholder]="
                      column.filterPlaceholder || 'SHARED.RESPONSIVE-TABLE.FILTER_PLACEHOLDER'
                        | translate
                    "
                    [ngModel]="filterValues()[column.filterKey || column.key]"
                    (ngModelChange)="onFilterChange(column.filterKey || column.key, $event)"
                    (enterPressed)="applyFilters()"
                    [iconRight]="'fa-solid fa-magnifying-glass'"
                  ></lib-custom-input>
                }
                @if (column.filterType === 'date' || column.filterType === 'date-range') {
                  <lib-custom-date-input
                    [displayError]="false"
                    [placeholder]="
                      column.filterPlaceholder || 'SHARED.RESPONSIVE-TABLE.FILTER_PLACEHOLDER'
                        | translate
                    "
                    [ngModel]="filterValues()[column.filterKey || column.key]"
                    (ngModelChange)="
                      onFilterChange(column.filterKey || column.key, $event); applyFilters()
                    "
                    [selectionMode]="column.filterType === 'date-range' ? 'range' : 'single'"
                  ></lib-custom-date-input>
                }
                @if (column.filterType === 'select-single') {
                  <lib-custom-select
                    [displayError]="false"
                    [options]="column.filterOptions || []"
                    [placeholder]="
                      column.filterPlaceholder || 'SHARED.RESPONSIVE-TABLE.SELECT_PLACEHOLDER'
                        | translate
                    "
                    [ngModel]="filterValues()[column.filterKey || column.key]"
                    (ngModelChange)="
                      onFilterChange(column.filterKey || column.key, $event); applyFilters()
                    "
                  ></lib-custom-select>
                }
                @if (column.filterType === 'select-multiple') {
                  <lib-custom-multi-select
                    [displayError]="false"
                    [options]="column.filterOptions || []"
                    [placeholder]="
                      column.filterPlaceholder || 'SHARED.RESPONSIVE-TABLE.SELECT_PLACEHOLDER'
                        | translate
                    "
                    [ngModel]="filterValues()[column.filterKey || column.key]"
                    (ngModelChange)="
                      onFilterChange(column.filterKey || column.key, $event); applyFilters()
                    "
                  ></lib-custom-multi-select>
                }
              </div>
            }
          }
          @if (showClearFiltersButton()) {
            <lib-custom-button
              [label]="'Borrar filtros' | translate"
              variant="danger-light"
              icon="fa-solid fa-xmark"
              size="md"
              (clicked)="clearFilters()"
              [disabled]="loading()"
              class="ml-6"
            ></lib-custom-button>
          }
          @if (serverSideLoad() || serverSideFiltering()) {
            <lib-custom-button
              [label]="'SHARED.RESPONSIVE-TABLE.SEARCH_BUTTON_TITLE' | translate"
              variant="primary"
              icon="fa-solid fa-magnifying-glass"
              size="md"
              (clicked)="applyFilters()"
              [disabled]="loading()"
              class="ml-6"
            ></lib-custom-button>
          }
        </div>
      }
      <div class="overflow-x-auto">
        <table class="min-w-full divide-y divide-gray-300">
          <thead>
            <tr>
              @if (rowSelectable()) {
                <th
                  scope="col"
                  class="px-[16px] py-[8px] text-left text-[12px] font-bold tracking-wider"
                  [title]="title() | translate"
                >
                  <input
                    type="checkbox"
                    class="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
                    [checked]="headerCheckboxState().checked"
                    [indeterminate]="headerCheckboxState().indeterminate"
                    (change)="toggleSelectAll()"
                    [disabled]="paginatedItems().length === 0"
                  />
                </th>
              }
              @for (col of columns(); track col.key) {
                <th
                  scope="col"
                  class="top-0 z-10 bg-white px-[16px] py-[8px] text-left text-[12px] font-bold tracking-wider"
                  [class.cursor-pointer]="col.sortable"
                  [class.select-none]="col.sortable"
                  [class.hover:bg-gray-50]="col.sortable"
                  [title]="col.label | translate"
                  (click)="col.sortable ? onSortColumn(col.key) : null"
                >
                  <span class="inline-flex items-center gap-1">
                    {{ col.label | translate }}
                    @if (col.sortable) {
                      <span class="inline-flex flex-col leading-none">
                        @if (_sortState()?.key === col.key && _sortState()?.direction === 'asc') {
                          <i class="fa-solid fa-arrow-down-a-z text-basic text-[10px]"></i>
                        } @else if (
                          _sortState()?.key === col.key && _sortState()?.direction === 'desc'
                        ) {
                          <i class="fa-solid fa-arrow-down-z-a text-basic text-[10px]"></i>
                        } @else {
                          <i class="fa-solid fa-sort text-basic text-[10px]"></i>
                        }
                      </span>
                    }
                  </span>
                </th>
              }
              @if (actionDefinitions().length > 0 || serverSideLoad()) {
                <th
                  scope="col"
                  class="top-0 right-0 z-20 bg-white px-6 py-3 text-left text-[12px] font-bold tracking-wider"
                  [title]="actionsColumnLabel() || title() | translate"
                >
                  @if (actionsColumnLabel()) {
                    {{ actionsColumnLabel() | translate }}
                  } @else {
                    <span class="sr-only">{{
                      'SHARED.RESPONSIVE-TABLE.SR_ACTIONS_LABEL' | translate
                    }}</span>
                  }
                </th>
              }
            </tr>
          </thead>
          <tbody class="bg-transparent">
            @for (item of paginatedItems(); track $index) {
              <tr class="group hover:bg-gray-50" [class.bg-indigo-50]="isRowSelected(item)">
                @if (rowSelectable()) {
                  <td
                    class="px-6 py-2 whitespace-nowrap text-[14px] text-gray-700"
                    [title]="title() | translate"
                  >
                    <input
                      type="checkbox"
                      class="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
                      [checked]="isRowSelected(item)"
                      (change)="toggleRowSelection(item)"
                    />
                  </td>
                }
                @for (col of columns(); track col.key) {
                  <td
                    class="px-6 py-2 whitespace-nowrap text-[14px] text-gray-700"
                    [title]="col.label | translate"
                  >
                    @if (col.columnType === 'image') {
                      <img [src]="getNestedProperty(item, col.key)" class="h-[30px]" />
                    } @else if (col.columnType === 'dictionary') {
                      {{ col.dictionaryKey?.[getNestedProperty(item, col.key)] || '' | translate }}
                    } @else if (col.columnType === 'currency') {
                      {{
                        getNestedProperty(item, col.key)
                          | currency: getValidCurrencyCode(col.currencyCode) : 'symbol' : '1.2-2'
                      }}
                    } @else if (col.columnType === 'date') {
                      {{ getNestedProperty(item, col.key) | date: col.dateFormat || 'shortDate' }}
                    } @else {
                      <div [innerHTML]="getNestedProperty(item, col.key)"></div>
                    }
                  </td>
                }
                <td
                  class="right-0 z-10 group-hover:bg-gray-50 px-6 py-2 whitespace-nowrap text-right text-[14px] font-medium"
                  [title]="title() | translate"
                >
                  @if (actionDefinitions().length > 0) {
                    <div class="flex flex-no-wrap gap-2 justify-end">
                      @for (action of actionDefinitions(); track action.actionKey) {
                        @if (
                          permissionsService.hasPermissions(action.permissions) &&
                          (!action.condition || action.condition(item))
                        ) {
                          @if (action.actionType === 'switch') {
                            <lib-custom-switch
                              [ngModel]="getNestedProperty(item, action.actionKey)"
                              (ngModelChange)="onGenericActionClick(action.actionKey, item)"
                              [displayError]="false"
                              class="mb-0"
                            ></lib-custom-switch>
                          } @else {
                            <button
                              type="button"
                              (click)="onGenericActionClick(action.actionKey, item)"
                              [title]="action.label | translate"
                              class="p-2 rounded-2xl hover:bg-gray-100 cursor-pointer"
                            >
                              @if (action.iconClass) {
                                <i [ngClass]="action.iconClass"></i>
                              } @else {
                                <span class="text-[12px] font-medium">{{
                                  action.label | translate
                                }}</span>
                              }
                            </button>
                          }
                        }
                      }
                    </div>
                  }
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    } @else if (useCardsView()) {
      <!-- Vista móvil (cards) -->

      <!-- Mobile Filters Section -->
      @if (shouldShowFilterRow()) {
        <div class="mb-4 rounded-2xl text-center bg-primary_container shadow-sm overflow-hidden">
          <div
            (click)="toggleMobileFilters()"
            class="py-2 px-4 flex items-center text-primary_dark"
          >
            <i class="fas fa-filter mr-2"></i>
            <span class="text-[20px]"
              >{{ isMobileFiltersExpanded() ? 'Ocultar' : 'Mostrar' }} filtros de búsqueda</span
            >
          </div>
          @if (isMobileFiltersExpanded()) {
            <div class="space-y-4 bg-white p-2">
              @for (column of columns(); track column.key) {
                @if (column.filterType && column.filterType !== 'none') {
                  <div>
                    @if (column.filterType === 'text') {
                      <lib-custom-input
                        [displayError]="false"
                        [id]="column.key + '-filter-mobile'"
                        [placeholder]="
                          column.filterPlaceholder || 'SHARED.RESPONSIVE-TABLE.FILTER_PLACEHOLDER'
                            | translate
                        "
                        [ngModel]="filterValues()[column.filterKey || column.key]"
                        (ngModelChange)="onFilterChange(column.filterKey || column.key, $event)"
                        (enterPressed)="applyFilters()"
                      ></lib-custom-input>
                    }
                    @if (column.filterType === 'date') {
                      <lib-custom-date-input
                        [displayError]="false"
                        [id]="column.key + '-filter-mobile'"
                        [placeholder]="
                          column.filterPlaceholder || 'SHARED.RESPONSIVE-TABLE.FILTER_PLACEHOLDER'
                            | translate
                        "
                        [ngModel]="filterValues()[column.filterKey || column.key]"
                        (ngModelChange)="
                          onFilterChange(column.filterKey || column.key, $event); applyFilters()
                        "
                      ></lib-custom-date-input>
                    }
                    @if (column.filterType === 'select-single') {
                      <lib-custom-select
                        [displayError]="false"
                        [id]="column.key + '-filter-mobile'"
                        [options]="column.filterOptions || []"
                        [placeholder]="
                          column.filterPlaceholder || 'SHARED.RESPONSIVE-TABLE.SELECT_PLACEHOLDER'
                            | translate
                        "
                        [ngModel]="filterValues()[column.filterKey || column.key]"
                        (ngModelChange)="
                          onFilterChange(column.filterKey || column.key, $event); applyFilters()
                        "
                      ></lib-custom-select>
                    }
                    @if (column.filterType === 'select-multiple') {
                      <lib-custom-multi-select
                        [displayError]="false"
                        [id]="column.key + '-filter-mobile'"
                        [options]="column.filterOptions || []"
                        [placeholder]="
                          column.filterPlaceholder || 'SHARED.RESPONSIVE-TABLE.SELECT_PLACEHOLDER'
                            | translate
                        "
                        [ngModel]="filterValues()[column.filterKey || column.key]"
                        (ngModelChange)="
                          onFilterChange(column.filterKey || column.key, $event); applyFilters()
                        "
                      ></lib-custom-multi-select>
                    }
                  </div>
                }
              }
              <!-- Filter Actions -->
              <div class="mt-4">
                @if (serverSideLoad() || serverSideFiltering()) {
                  <lib-custom-button
                    [label]="'SHARED.RESPONSIVE-TABLE.SEARCH_BUTTON_TEXT' | translate"
                    [disabled]="loading()"
                    [variant]="hasPendingServerFilters() ? 'primary' : 'primary'"
                    icon="fa fa-search"
                    [fullWidth]="true"
                    (clicked)="applyFilters()"
                    class="mb-2"
                  ></lib-custom-button>
                }
                @if (showClearFiltersButton()) {
                  <lib-custom-button
                    [label]="'SHARED.RESPONSIVE-TABLE.CLEAR_BUTTON_TEXT' | translate"
                    [disabled]="loading()"
                    variant="danger-light"
                    icon="fa fa-times"
                    [fullWidth]="true"
                    (clicked)="clearFilters()"
                  ></lib-custom-button>
                }
              </div>
            </div>
          }
        </div>
      }

      <div [class]="currentCardsGrid">
        @for (item of paginatedItems(); track $index) {
          @if (itemTemplate()) {
            <ng-container
              [ngTemplateOutlet]="itemTemplate()"
              [ngTemplateOutletContext]="{ $implicit: item, desktop: false, viewMode: viewMode }"
            ></ng-container>
          } @else {
            <!-- Generic Card View -->
            <div
              class="bg-white shadow-sm rounded-lg border border-gray-200"
              [class.border-indigo-500]="isRowSelected(item)"
              [class.bg-indigo-50]="isRowSelected(item)"
            >
              @if (rowSelectable()) {
                <div class="flex items-center mb-2 pb-2 border-b border-gray-200">
                  <input
                    type="checkbox"
                    class="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500 mr-3"
                    [checked]="isRowSelected(item)"
                    (change)="toggleRowSelection(item)"
                  />
                  <!--
                <span class="font-semibold text-gray-700">{{ 'SHARED.RESPONSIVE-TABLE.SELECT_ROW' | translate }}</span>
                --></div>
              }
              <ng-container *ngFor="let col of columns(); let i = index">
                <div
                  class="grid grid-cols-[1fr_1fr] gap-2"
                  [ngClass]="i !== 0 ? 'border-t border-gray-200' : ''"
                >
                  <div class="py-1 px-2 flex items-center min-w-0">
                    <div class="font-bold truncate">{{ col.label | translate }}:</div>
                  </div>
                  <div class="py-1 px-2 overflow-hidden text-ellipsis whitespace-nowrap">
                    @if (col.columnType === 'image') {
                      <img [src]="getNestedProperty(item, col.key)" class="h-[30px]" />
                    } @else if (col.columnType === 'dictionary') {
                      {{ col.dictionaryKey?.[getNestedProperty(item, col.key)] || '' | translate }}
                    } @else if (col.columnType === 'currency') {
                      {{
                        getNestedProperty(item, col.key)
                          | currency: getValidCurrencyCode(col.currencyCode) : 'symbol' : '1.2-2'
                      }}
                    } @else if (col.columnType === 'date') {
                      {{ getNestedProperty(item, col.key) | date: col.dateFormat || 'shortDate' }}
                    } @else {
                      <div
                        [innerHTML]="getNestedProperty(item, col.key)"
                        class="overflow-hidden text-ellipsis whitespace-nowrap"
                      ></div>
                    }
                  </div>
                </div>
              </ng-container>
              @if (actionDefinitions().length > 0) {
                <div class="py-1 px-2 flex justify-end space-x-2 bg-primary_container">
                  @for (action of actionDefinitions(); track action.actionKey) {
                    @if (
                      permissionsService.hasPermissions(action.permissions) &&
                      (!action.condition || action.condition(item))
                    ) {
                      @if (action.actionType === 'switch') {
                        <lib-custom-switch
                          [ngModel]="getNestedProperty(item, action.actionKey)"
                          (ngModelChange)="onGenericActionClick(action.actionKey, item)"
                          [displayError]="false"
                          class="mb-0"
                        ></lib-custom-switch>
                      } @else {
                        <button
                          type="button"
                          (click)="onGenericActionClick(action.actionKey, item)"
                          [title]="action.label | translate"
                          class="p-2 rounded-full hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-1 focus:ring-indigo-500"
                        >
                          @if (action.iconClass) {
                            <i [ngClass]="action.iconClass" class="hover:text-indigo-900"></i>
                          } @else {
                            <span class="text-[12px] font-medium">{{
                              action.label | translate
                            }}</span>
                          }
                        </button>
                      }
                    }
                  }
                </div>
              }
            </div>
          }
        }
      </div>
    }

    <!--Sin resultados-->
    @if (paginatedItems().length === 0) {
      <div class="flex flex-col items-center justify-center my-12">
        @if (loading()) {
          <span
            class="animate-spin rounded-full h-5 w-5 border-t-2 border-b-2 border-primary"
          ></span>
        } @else {
          <i class="fa-solid fa-circle-exclamation text-caption_light text-[48px]"></i>
        }
        <p class="text-center font-bold text-caption_light text-[20px] mt-2">
          {{ loading() ? 'Cargando...' : '¡No hay resultados!' }}
        </p>
      </div>
    }

    <!-- New Pagination Controls -->
    @if (totalPages() > 0) {
      <div class="flex justify-end items-center mt-6">
        <nav class="flex items-center space-x-2" aria-label="Pagination">
          <!-- Previous Button -->
          @if (totalPages() > 1) {
            <button
              (click)="onPreviousPage()"
              [disabled]="effectiveCurrentPage() === 1 || loading()"
              class="relative cursor-pointer inline-flex items-center px-3 py-2 rounded-xl border border-caption_light bg-white text-[14px] font-bold hover:bg-primary-50 disabled:text-caption_light disabled:cursor-not-allowed"
              [attr.aria-label]="'SHARED.RESPONSIVE-TABLE.PREVIOUS_BUTTON' | translate"
            >
              <!-- Heroicon name: solid/chevron-left -->
              <svg
                class="h-5 w-5"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
                aria-hidden="true"
              >
                <path
                  fill-rule="evenodd"
                  d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                  clip-rule="evenodd"
                />
              </svg>
              <span>{{ 'SHARED.RESPONSIVE-TABLE.PREVIOUS_BUTTON' | translate }}</span>
            </button>

            @for (page of paginationPages(); track $index) {
              @if (page === '...') {
                <span class="px-[12px] py-[6px] text-[14px] font-bold text-normal">...</span>
              } @else {
                <button
                  (click)="goToPage(+page)"
                  [class.bg-primary]="+page === effectiveCurrentPage()"
                  [class.border-primary]="+page === effectiveCurrentPage()"
                  [class.text-white]="+page === effectiveCurrentPage()"
                  [class.z-10]="+page === effectiveCurrentPage()"
                  [class.border-gray-300]="+page !== effectiveCurrentPage()"
                  [class.text-normal]="+page !== effectiveCurrentPage()"
                  [class.hover:bg-primary]="+page !== effectiveCurrentPage()"
                  [class.hover:text-white]="+page !== effectiveCurrentPage()"
                  [disabled]="loading()"
                  class="relative cursor-pointer inline-flex items-center px-4 py-2 rounded-xl border text-[14px] font-bold disabled:text-caption_light disabled:cursor-not-allowed"
                >
                  {{ page }}
                </button>
              }
            }

            <!-- Next Button -->
            <button
              (click)="onNextPage()"
              [disabled]="effectiveCurrentPage() === totalPages() || loading()"
              class="relative cursor-pointer inline-flex items-center px-3 py-2 rounded-xl border border-caption_light bg-white text-[14px] font-bold hover:bg-primary-50 disabled:text-caption_light disabled:cursor-not-allowed"
              [attr.aria-label]="'SHARED.RESPONSIVE-TABLE.NEXT_BUTTON' | translate"
            >
              <span>{{ 'SHARED.RESPONSIVE-TABLE.NEXT_BUTTON' | translate }}</span>
              <!-- Heroicon name: solid/chevron-right -->
              <svg
                class="h-5 w-5"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
                aria-hidden="true"
              >
                <path
                  fill-rule="evenodd"
                  d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                  clip-rule="evenodd"
                />
              </svg>
            </button>
          }
          <!-- Show Limit Button -->
          <lib-custom-select
            [displayError]="false"
            [id]="'show-limit'"
            [options]="showLimitItems()"
            [ngModel]="itemsPerPage()"
            (ngModelChange)="onLimitItemsPage($event)"
            placeholderDynamic="Mostrar"
            [outlined]="true"
            [mb]="false"
          ></lib-custom-select>
        </nav>
      </div>
    }
  </div>
</div>
